import React, { useState } from 'react';
import styles from './style.module.scss';
import { Button, Upload } from 'antd';
import MenuService from '../../services/MenuService';

const EditCard = (props) => {
    const { secEdit, setSecEdit, onUpdateGroup } = props;
    const onSectionChange = (e) => {
        const cardData = {...secEdit};
        cardData[e.target.name] = e.target.value;
        setSecEdit(cardData);
    };
    const uploadImage = async(options) =>{
        const { onSuccess, onError, file, onProgress } = options;
        const formData = new FormData();
        formData.append('file', file);
        const urlResponse = await MenuService.uploadMenuItemPhoto(formData);  
        const newItemList = { ...secEdit }
        newItemList.photo_url = urlResponse.url;
        setSecEdit(newItemList);
        onSuccess(true);
    };
    return <div className={styles.add_sec}>
        <div className={styles.upload_btn}>
             <Upload fileList={[]} customRequest={uploadImage}>
             {secEdit.photo_url ?
                <div className={styles.menu_uploads}>
                     <img
                     src={secEdit.photo_url}
                     alt="avatar"
                     style={{
                         width: '100%',
                         height: 'inherit'
                     }}
                     /> 
                 </div> 
                 :
                 <div className={styles.menu_uploads}>
                    <div>
                        <img src="/images/upload.png" alt="FoodLuv" />
                        <p>Upload image</p>
                    </div>
                </div>}
            </Upload>
        </div>
        <div><input className={styles.addsec_label} value={secEdit.name} name="name" placeholder='Enter Section name here' onChange={(e)=>{onSectionChange(e)}}/></div>
        <div className={styles.editsec_label}>
            <Button type="primary" style={{marginRight: 10}} onClick={()=>{onUpdateGroup()}}>Save</Button>
            <Button type="primary" className={styles.sec_cancel} onClick={()=>{ setSecEdit({}) }}>Cancel</Button>
        </div>
    </div>
};
export default EditCard;